export default __webpack_public_path__ + "static/media/pantry1-afterA-2048w.5ff21bc9.avif";